import SlimSelect from 'slim-select'

export function select(){
    if(document.querySelector('select')){
        document.querySelectorAll('select').forEach((item) => {
            new SlimSelect({
                select: item,
                settings: {
                    showSearch: false
                }
            })
        })
    }
}